interface Experiment<ParamValues> {
    name: string;
    paramName: string;
    values: ParamValues;
}

enum HomepageBannerCTAValues {
    control = 'control',
    location = 'location',
}
export const HomepageBannerCTAExperiment: Experiment<
    typeof HomepageBannerCTAValues
> = {
    name: 'homepage_banner_cta',
    paramName: 'cta_string',
    values: HomepageBannerCTAValues,
};
